module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 400 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter01"
  }, [_vm._v("Atomism")]), _vm._v(" "), _c('p', {
    staticClass: "seealso_fm2"
  }, [_c('strong', [_vm._v("Democritus")]), _vm._v(" (c. 460–c. 370 BCE)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("When, you look back on the ancient Greeks, sometimes it’s as if the years between them and us have suddenly grown thin enough to see through. You come across a theory that seems to be so perfectly on target that you wish you could reach out and shake the originator’s hand. British mathematician G. H. Hardy captured this feeling when he said that, to him, the Greek mathematicians were “fellows of another College.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fifth-century Greek philosopher Leucippus seems to have been the originator of the idea of "), _c('em', [_vm._v("atomism")]), _vm._v(", which takes reductionism all the way down, proposing that everything is made out of extremely small, indivisible particles. His more famous pupil, Democritus, developed the theory further: Atoms, he believed, came in a huge number of varieties, and the physical properties of materials had something to do with the microscopic properties of the atoms themselves. Some of them were very slippery and tumbled easily past each other, while others stuck together strongly to make hard and dense materials. The explanations for why the atoms acted this way were not (of course) very sophisticated, but the key points are absolutely correct, and the theory is rightly considered one of the great achievements of Greek thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Atomism was also noteworthy for being thoroughly "), _c('em', [_vm._v("materialist")]), _vm._v("—that is, it didn’t try to explain things through talk of purposes and desires. Rather, things were treated mechanistically; we see something happening, therefore something “material” must have happened earlier to cause it. To take an example, a rock is hard because of some physical reason that could be investigated, not just because it was somehow necessary for it to be hard in the grand scheme of things. The outlines of modern scientific thinking are clearly visible here.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Sceptical Chymist")]), _vm._v(" (1661)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dalton’s Atomic Theory (1808)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maxwell-Boltzmann Distribution (1877)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/029.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Democritus, in this 1628 work by Dutch painter Hendrick ter Brugghen (1588–1629), comes out looking rather Dutch himself.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb23ebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c08.vue
// module id = 99
// module chunks = 0